import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-27f1c43a")

_pushScopeId("data-v-27f1c43a")
const _hoisted_1 = { class: "p-m-5" }
const _hoisted_2 = {
  key: 0,
  class: "p-mt-5"
}
const _hoisted_3 = { id: "import-metadata-spinner" }
const _hoisted_4 = {
  id: "import-progress-message",
  class: "p-d-flex p-jc-center p-ai-center"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Button = _resolveComponent("Button")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-m-2" }, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.businessModelManager.metadata')), 1)
        ]),
        _: 1
      })
    ]),
    content: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Button, {
          id: "metadata-button",
          class: "p-jc-center",
          onClick: _ctx.confirmImport
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.businessModelManager.importMetadata')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        (_ctx.importing)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_ProgressSpinner)
              ]),
              _createVNode(_component_ProgressBar, {
                mode: "indeterminate",
                class: "kn-progress-bar"
              }),
              _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('managers.businessModelManager.importProgress')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
})